// extracted by mini-css-extract-plugin
export default {"PortfolioEventsTable":"PortfolioEventsTable_PortfolioEventsTable__5nWvz","eventsTableTitle":"PortfolioEventsTable_eventsTableTitle__-Pa9H"};